import React, { Component } from 'react';

function callback(entries) {
    entries.forEach(entry => entry?.target?.callback?.(entry));
}

const observer = 'IntersectionObserver' in window ? new IntersectionObserver(callback, {}) : null;

export default class RenderIfVisible extends Component {
    constructor(props) {
        super(props);

        this.state = {
            elem: null,
            show: false
        };
    }

    componentWillUnmount() {
        if (this.state.elem) {
            observer?.unobserve?.(this.state.elem);
        }
    }

    observe = elem => {
        if (elem) {
            this.setState({ elem });
            elem.callback = entry => {
                const show = entry.isIntersecting;
                if (this.state.show !== show) {
                    this.setState({ show });
                }
            }

            observer?.observe?.(elem);
        } else if (this.state.elem) {
            observer?.unobserve?.(this.state.elem);
            this.setState({ elem });
        }
    }

    render() {
        // remove props we use and pass the rest to the div
        const { render, ...props } = this.props;
        return (
            <div ref={this.observe} {...props}>
                {!observer || this.state.show ? this.props.render() : null}
            </div>
        );
    }
}